// src/components/admin/act/report/ACTQuestionRow.js
import React from "react";

const formatCorrect = (val) =>
  String(val || "")
    .split(/[,\s/|]+/)
    .map((t) => t.trim().toUpperCase())
    .filter(Boolean)
    .join(" / ");

const getQNumber = (item) => {
  const n = item?.questionNumber;
  if (typeof n === "number" && !Number.isNaN(n)) return n;
  const qid = String(item?.questionId || item?.id || "");
  const m = qid.match(/_Q(\d+)/i);
  if (m) return Number(m[1]);
  return "";
};

const styles = {
  row: { borderBottom: "1px solid #f3f4f6" },
  cell: { padding: "10px 8px", color: "#374151", whiteSpace: "nowrap", verticalAlign: "middle" },
  statusText: {
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
  },
  muted: { color: "#6b7280" },
  ans: { fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace", fontWeight: 800 },
  viewBtn: {
    fontSize: 12,
    fontWeight: 700,
    color: "#2563eb",
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 6,
    padding: "4px 10px",
    cursor: "pointer",
  },
};

export default function ACTQuestionRow({ item, onOpen }) {
  const qNum = getQNumber(item);

  const studentAnswer = String(item?.studentAnswer ?? "").trim().toUpperCase();
  const correctAnswer = formatCorrect(item?.correctAnswer);
  const status = item?.status || (studentAnswer ? (item?.isCorrect ? "Correct" : "Incorrect") : "Skipped");
  const category = item?.category || "—";

  // Determine Colors based on status
  const s = String(status).toLowerCase();
  let rowBg = "#ffffff";
  let statusTextColor = "#334155"; // Default grey

  if (s === "correct") {
    rowBg = "#f0fdf4"; 
    statusTextColor = "#059669"; // Green
  } else if (s === "incorrect") {
    rowBg = "#fef2f2"; 
    statusTextColor = "#dc2626"; // Red
  } else if (s === "skipped") {
    statusTextColor = "#64748b"; // Muted Slate
  }

  return (
    <tr style={{ ...styles.row, background: rowBg }}>
      <td style={styles.cell}>{qNum || "—"}</td>

      <td style={styles.cell}>
        <span style={{ ...styles.statusText, color: statusTextColor }}>
          {status}
        </span>
      </td>

      <td style={styles.cell}>{category}</td>

      <td style={styles.cell}>
        {studentAnswer ? <span style={styles.ans}>{studentAnswer}</span> : <span style={styles.muted}>—</span>}
      </td>

      <td style={styles.cell}>
        {correctAnswer ? <span style={styles.ans}>{correctAnswer}</span> : <span style={styles.muted}>—</span>}
      </td>

      <td style={styles.cell}>
        <button style={styles.viewBtn} onClick={() => onOpen(item)}>
          Open
        </button>
      </td>
    </tr>
  );
}